import styled from "@emotion/styled";
import {
  fontSize,
  duration,
  layout,
  spacing,
  nav,
  text,
} from "@atlas-int/tokens";

export const hamburgerMenuContainerHeight = "60px";

export const MenuHeaderContainer = styled.div`
  width: 100%;
  flex: 0 0 ${hamburgerMenuContainerHeight};
  display: flex;
  flex-direction: column;
  justify-content: center;

  &.expanded {
    flex: 0 0 auto;
  }
`;

export const ContentPageMenuHeaderContainer = styled.div`
  width: 100%;
  flex: 0 0 ${hamburgerMenuContainerHeight};
  background-color: ${nav.background};
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const MenuBodyContainer = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
`;

export const MenuHeaderActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;

export const HamburgerMenuButton = styled.button`
  background-color: transparent;
  border: none;
  text-transform: uppercase;
  width: ${layout.navBarWidth};
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: ${fontSize.xs};
  color: ${text.onDark};

  &:hover {
    cursor: pointer;
  }
`;

export const Icon = styled.span`
  display: flex;
  width: ${spacing[16]};
  height: ${spacing[8]};
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  flex-direction: column;
  justify-content: space-between;
`;
export const Bar = styled.span`
  display: inline-block;
  width: 100%;
  height: 0;
  border-top: 2px solid ${text.onDark};
  transition: all ${duration.base} ease;
`;
export const CenterBar = styled(Bar)`
  position: relative;

  &:before {
    content: "";
    display: inline-block;
    width: 100%;
    height: 0;
    border-top: 2px solid ${text.onDark};
    position: absolute;
    transform-origin: center;
    top: -2px;
    left: 0;
    transition: all ${duration.base} ease;
  }

  &.close__menu {
    transform: rotate(45deg);

    &:before {
      transform: rotate(90deg);
    }
  }
`;
